export default "__VITE_ASSET__UOOPXr83__"